(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var SECTION = 'cart-drawer';

    function rootUrl() {
      var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      return r.charAt(r.length - 1) === '/' ? r : r + '/';
    }

    function initCartDrawer() {
      var drawer = document.getElementById('CartDrawer');
      if (!drawer || drawer.dataset.initialized === 'true') return;
      drawer.dataset.initialized = 'true';

      var body = document.body;
      var overlay = document.getElementById('CartDrawerOverlay');
      var closeBtn = document.getElementById('CartDrawerClose');
      var drawerBody = document.getElementById('CartDrawerBody');
      var drawerFooter = document.getElementById('CartDrawerFooter');
      var lastFocus = null;

      function openDrawer() {
        // Close the mobile nav menu if it happens to be open.
        var mDrawer = document.getElementById('MobileDrawer');
        var mOverlay = document.getElementById('MobileOverlay');
        if (mDrawer) mDrawer.classList.remove('is-active');
        if (mOverlay) mOverlay.classList.remove('is-active');

        lastFocus = document.activeElement;
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        body.style.overflow = 'hidden';
        if (closeBtn) closeBtn.focus();
      }

      function closeDrawer() {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        body.style.overflow = '';
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      }

      window.WarforgeCart = { open: openDrawer, close: closeDrawer };

      function setLoading(state) { drawer.classList.toggle('is-loading', !!state); }

      // Reflect a new item count on every cart-count display in the theme.
      function updateCounts(count) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = count;
        });
        // The mobile header badge is only meaningful when there are items.
        document.querySelectorAll('.top-bar__mobile-cart-count').forEach(function (el) {
          el.hidden = count <= 0;
        });
      }

      // Swap the dynamic regions with freshly rendered section HTML.
      function renderDrawer(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newBody = doc.getElementById('CartDrawerBody');
        var newFooter = doc.getElementById('CartDrawerFooter');
        if (newBody) drawerBody.innerHTML = newBody.innerHTML;
        if (newFooter) drawerFooter.innerHTML = newFooter.innerHTML;
        var countHost = doc.getElementById('CartDrawer');
        if (countHost) updateCounts(parseInt(countHost.getAttribute('data-cart-total-count'), 10) || 0);
      }

      var noticeHost = document.getElementById('CartDrawerNotice');

      // Transient message in the drawer. kind: 'error' (red) or 'info' (accent).
      function showNotice(message, kind) {
        if (!message || !noticeHost) return;
        noticeHost.innerHTML = '';
        var note = document.createElement('div');
        note.className = 'cart-drawer__notice-item' + (kind === 'error' ? ' cart-drawer__notice-item--error' : '');
        note.setAttribute('role', kind === 'error' ? 'alert' : 'status');
        note.textContent = message;
        noticeHost.appendChild(note);
        openDrawer();
        clearTimeout(showNotice._t);
        showNotice._t = setTimeout(function () { if (noticeHost) noticeHost.innerHTML = ''; }, 5000);
      }

      // "Only N left" style message when the shopper hits the available stock.
      function showMaxNotice(max) {
        var tpl = drawer.getAttribute('data-max-qty-text') || '';
        showNotice(tpl ? tpl.replace('[[count]]', max) : '', 'info');
      }

      // --- Cart AJAX ---------------------------------------------------------
      // POST the form to the Cart AJAX API, then re-render the drawer.
      function postAddToCart(form) {
        var submitBtn = form.querySelector('[type="submit"]');
        var data = new FormData(form);
        data.append('sections', SECTION);
        data.append('sections_url', window.location.pathname);

        fetch(rootUrl() + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: data
        })
          .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
          .then(function (result) {
            if (!result.ok) { showNotice(result.json.description || result.json.message, 'error'); return; }
            if (result.json.sections && result.json.sections[SECTION]) renderDrawer(result.json.sections[SECTION]);
            openDrawer();
          })
          .catch(function () { form.submit(); }) // graceful fallback to native POST
          .finally(function () {
            if (submitBtn) { submitBtn.classList.remove('is-loading'); submitBtn.removeAttribute('disabled'); }
          });
      }

      // The stock cap (available qty) Liquid embeds on the add-to-cart form when
      // the variant is inventory-tracked AND overselling is off; null otherwise.
      function formStockCap(form) {
        var el = form.querySelector('[data-inv-available]');
        var v = el ? el.getAttribute('data-inv-available') : null;
        if (v === null || v === '') return null;
        var n = parseInt(v, 10);
        return isNaN(n) ? null : n;
      }

      function addToCart(form) {
        var submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) { submitBtn.classList.add('is-loading'); submitBtn.setAttribute('disabled', 'disabled'); }

        var cap = formStockCap(form);
        if (cap === null) { postAddToCart(form); return; }

        // /cart/add.js validates the requested quantity against stock but NOT
        // requested + what's already in the cart, so it happily oversells. Look up
        // the current line and block the add if the combined total exceeds stock.
        var idField = form.querySelector('[name="id"]');
        var variantId = idField ? String(idField.value) : '';
        var qtyField = form.querySelector('[name="quantity"]');
        var requested = qtyField ? (parseInt(qtyField.value, 10) || 1) : 1;

        fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            var inCart = 0;
            (cart.items || []).forEach(function (it) { if (String(it.id) === variantId) inCart += it.quantity; });
            if (inCart + requested > cap) {
              if (submitBtn) { submitBtn.classList.remove('is-loading'); submitBtn.removeAttribute('disabled'); }
              showMaxNotice(cap); // opens the drawer + shows the localized stock message
              return;
            }
            postAddToCart(form);
          })
          .catch(function () { postAddToCart(form); }); // fail open: let Shopify decide
      }

      // Re-render the drawer from the live cart so the UI reverts to the
      // real quantities (used after a rejected change).
      function refreshDrawer() {
        fetch(rootUrl() + '?section_id=' + SECTION)
          .then(function (res) { return res.ok ? res.text() : null; })
          .then(function (html) { if (html) renderDrawer(html); })
          .catch(function () {});
      }

      function changeLine(key, quantity) {
        setLoading(true);
        fetch(rootUrl() + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity, sections: SECTION, sections_url: window.location.pathname })
        })
          .then(function (res) {
            return res.json().then(function (json) { return { ok: res.ok, json: json }; });
          })
          .then(function (result) {
            if (!result.ok) {
              // Most common cause: requesting more than the available stock,
              // which Shopify rejects with 422 and a localized description.
              // Surface it and re-sync so the quantity reverts instead of
              // silently doing nothing.
              showNotice(result.json.description || result.json.message, 'error');
              refreshDrawer();
              return;
            }
            var cart = result.json;
            if (cart.sections && cart.sections[SECTION]) renderDrawer(cart.sections[SECTION]);
            else if (typeof cart.item_count === 'number') updateCounts(cart.item_count);
          })
          .catch(function () { refreshDrawer(); })
          .finally(function () { setLoading(false); });
      }

      // --- Listeners ---------------------------------------------------------
      // Intercept add-to-cart submissions (product cards + PDP).
      document.addEventListener('submit', function (e) {
        var form = e.target;
        if (!(form instanceof HTMLFormElement)) return;
        var action = form.getAttribute('action') || '';
        if (action.indexOf('/cart/add') === -1) return;
        e.preventDefault();
        addToCart(form);
      });

      // Open the drawer from any cart link instead of navigating to /cart.
      document.addEventListener('click', function (e) {
        var link = e.target.closest('a[href]');
        if (!link || link.hasAttribute('data-cart-view')) return;
        var path;
        try { path = new URL(link.href, window.location.origin).pathname; } catch (err) { return; }
        if (/\/cart\/?$/.test(path)) { e.preventDefault(); openDrawer(); }
      });

      // Close interactions.
      if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
      if (overlay) overlay.addEventListener('click', closeDrawer);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
      });

      // Quantity steppers + remove (delegated so refreshed markup keeps working).
      drawerBody.addEventListener('click', function (e) {
        var removeBtn = e.target.closest('[data-cart-remove]');
        if (removeBtn) { changeLine(removeBtn.getAttribute('data-cart-remove'), 0); return; }

        var stepBtn = e.target.closest('[data-cart-qty]');
        if (!stepBtn) return;
        var item = stepBtn.closest('.cart-drawer__item');
        var input = item && item.querySelector('[data-cart-qty-input]');
        if (!item || !input) return;
        var current = parseInt(input.value, 10) || 0;
        var max = parseInt(input.getAttribute('max'), 10);
        var next = stepBtn.getAttribute('data-cart-qty') === 'plus' ? current + 1 : current - 1;
        if (next < 0) next = 0;
        // Don't try to exceed available stock — tell the shopper it's the max.
        if (!isNaN(max) && next > max) { showMaxNotice(max); return; }
        if (next === current) return;
        changeLine(item.getAttribute('data-key'), next);
      });

      drawerBody.addEventListener('change', function (e) {
        var input = e.target.closest('[data-cart-qty-input]');
        if (!input) return;
        var item = input.closest('.cart-drawer__item');
        if (!item) return;
        var qty = parseInt(input.value, 10);
        if (isNaN(qty) || qty < 0) qty = 0;
        var max = parseInt(input.getAttribute('max'), 10);
        if (!isNaN(max) && qty > max) { qty = max; input.value = max; showMaxNotice(max); }
        changeLine(item.getAttribute('data-key'), qty);
      });
    }

    // Defer drawer wiring to idle so it stays off the critical path and out
    // of the page-transition window (add-to-cart still works before it binds,
    // just via a normal POST until the AJAX intercept attaches).
    var bootCart = function () {
      if ('requestIdleCallback' in window) requestIdleCallback(initCartDrawer, { timeout: 300 });
      else setTimeout(initCartDrawer, 50);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootCart);
    else bootCart();
    document.addEventListener('shopify:section:load', initCartDrawer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  function initCartAutoUpdate() {
    const cartForm = document.querySelector('.cart-form');
    if (!cartForm) return;

    const quantitySelectors = document.querySelectorAll('.quantity-selector');
    quantitySelectors.forEach(selector => {
      const input = selector.querySelector('.quantity-input');
      const minusBtn = selector.querySelector('[data-action="minus"]');
      const plusBtn = selector.querySelector('[data-action="plus"]');

      minusBtn.addEventListener('click', () => {
        const current = parseInt(input.value) || 0;
        if (current > 0) {
          input.value = current - 1;
          cartForm.submit(); 
        }
      });

      plusBtn.addEventListener('click', () => {
        const current = parseInt(input.value) || 0;
        input.value = current + 1;
        cartForm.submit();
      });

      // Also submit on direct manual input change
      input.addEventListener('change', () => {
        cartForm.submit();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initCartAutoUpdate);
  document.addEventListener('shopify:section:load', initCartAutoUpdate);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-grid-native"]) return;
  try {
    
  function initCollectionNative() {
    const form = document.getElementById('CollectionFiltersForm');
    if (!form) return;

    const autoSubmitInputs = form.querySelectorAll('input[type="checkbox"], select[name="sort_by"]');
    autoSubmitInputs.forEach((input) => {
      input.addEventListener('change', () => form.submit());
    });
  }

  document.addEventListener('DOMContentLoaded', initCollectionNative);
  document.addEventListener('shopify:section:load', initCollectionNative);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-grid"]) return;
  try {
    
  function initCollectionNative() {
    const searchParams = new URLSearchParams(window.location.search);
    const debugFilters = searchParams.get('debug_filters') == '1';
    const sectionRoot = document.querySelector('[data-section-type="collection-native"]');
    const drawer = document.querySelector('[data-filter-drawer]');
    const toggles = document.querySelectorAll('[data-filter-toggle]');
    const closeButton = document.querySelector('[data-filter-close]');
    const overlay = document.querySelector('[data-filter-overlay]');
    const mobileView = window.matchMedia('(max-width: 992px)').matches;
    let priceFiltersInitialized = false;

    const initPriceFilters = (form) => {
      if (priceFiltersInitialized) return;
      priceFiltersInitialized = true;

      const priceFilters = form.querySelectorAll('[data-price-filter]');
      priceFilters.forEach((priceFilter) => {
        const minRange = priceFilter.querySelector('[data-min-range]');
        const maxRange = priceFilter.querySelector('[data-max-range]');
        const minInput = priceFilter.querySelector('[data-min-input]');
        const maxInput = priceFilter.querySelector('[data-max-input]');
        const fill = priceFilter.querySelector('[data-range-fill]');

        if (!minRange || !maxRange || !minInput || !maxInput || !fill) return;

        const maxLimit = Number(maxRange.max || 0);
        if (maxLimit <= 0) return;

        const clampValue = (value, min, max) => {
          if (Number.isNaN(value)) return min;
          return Math.min(Math.max(value, min), max);
        };

        const updateFill = () => {
          const min = Number(minRange.value || 0);
          const max = Number(maxRange.value || maxLimit);
          const minPercent = (min / maxLimit) * 100;
          const maxPercent = (max / maxLimit) * 100;
          fill.style.left = `${minPercent}%`;
          fill.style.right = `${100 - maxPercent}%`;
        };

        const syncFromRange = (source) => {
          let min = Number(minRange.value || 0);
          let max = Number(maxRange.value || maxLimit);

          if (min > max) {
            if (source === 'min') {
              max = min;
              maxRange.value = String(max);
            } else {
              min = max;
              minRange.value = String(min);
            }
          }

          minInput.value = String(min);
          maxInput.value = String(max);
          updateFill();
        };

        const syncFromInput = (source) => {
          let min = clampValue(Number(minInput.value || 0), 0, maxLimit);
          let max = clampValue(Number(maxInput.value || maxLimit), 0, maxLimit);

          if (min > max) {
            if (source === 'min') {
              max = min;
              maxInput.value = String(max);
            } else {
              min = max;
              minInput.value = String(min);
            }
          }

          minRange.value = String(min);
          maxRange.value = String(max);
          updateFill();
        };

        minRange.addEventListener('input', () => syncFromRange('min'));
        maxRange.addEventListener('input', () => syncFromRange('max'));
        minInput.addEventListener('input', () => syncFromInput('min'));
        maxInput.addEventListener('input', () => syncFromInput('max'));
        minInput.addEventListener('change', () => syncFromInput('min'));
        maxInput.addEventListener('change', () => syncFromInput('max'));

        updateFill();
      });
    };

    const closeDrawer = () => {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      if (overlay) overlay.hidden = true;
      toggles.forEach((toggle) => toggle.setAttribute('aria-expanded', 'false'));
      document.body.classList.remove('filters-drawer-open');
    };

    const openDrawer = () => {
      if (!drawer) return;
      drawer.classList.add('is-open');
      if (overlay) overlay.hidden = false;
      toggles.forEach((toggle) => toggle.setAttribute('aria-expanded', 'true'));
      document.body.classList.add('filters-drawer-open');

      const form = document.getElementById('CollectionFiltersForm');
      if (mobileView && form) {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(() => initPriceFilters(form), { timeout: 800 });
        } else {
          setTimeout(() => initPriceFilters(form), 160);
        }
      }
    };

    if (toggles.length > 0) {
      toggles.forEach((toggle) => {
        if (toggle.dataset.filterToggleBound == 'true') return;
        toggle.dataset.filterToggleBound = 'true';

        const onToggle = (event) => {
          event.preventDefault();
          if (!drawer) return;
          if (drawer.classList.contains('is-open')) {
            closeDrawer();
          } else {
            openDrawer();
          }
        };

        toggle.addEventListener('click', onToggle);
      });
    }

    const form = document.getElementById('CollectionFiltersForm');
    if (!form) return;
    if (form.dataset.collectionInit == 'true') return;
    form.dataset.collectionInit = 'true';

    const logFilterDebug = (tag) => {
      if (!debugFilters) return;

      const groups = Array.from(form.querySelectorAll('.filter-group'));
      const activeLinks = form.querySelectorAll('.filter-item__link.is-active').length;
      const priceBlocks = form.querySelectorAll('[data-price-filter]').length;
      const labels = groups.map((group) => {
        const summary = group.querySelector('.filter-group__title');
        return summary ? summary.textContent.trim() : 'unknown';
      });

      console.group(`[filter-debug] ${tag}`);
      console.log('href:', window.location.href);
      console.log('collectionHandle:', sectionRoot ? sectionRoot.dataset.collectionHandle : null);
      console.log('collectionProductsCount:', sectionRoot ? sectionRoot.dataset.collectionProductsCount : null);
      console.log('collectionFiltersSize:', sectionRoot ? sectionRoot.dataset.collectionFiltersSize : null);
      console.log('renderedGroups:', groups.length);
      console.log('renderedPriceBlocks:', priceBlocks);
      console.log('activeFilterLinks:', activeLinks);
      console.log('groupLabels:', labels);
      console.groupEnd();
    };

    logFilterDebug('init');

    if (!mobileView) {
      initPriceFilters(form);
    }

    if (closeButton) closeButton.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', (event) => {
      if (event.key == 'Escape') {
        closeDrawer();
      }
    });

    let wasMobile = null;
    const applyMobileFilterState = () => {
      const mobile = window.matchMedia('(max-width: 992px)').matches;
      if (wasMobile === mobile) return;
      wasMobile = mobile;

      if (!mobile) {
        closeDrawer();
        return;
      }

      const groups = form.querySelectorAll('.filter-group');
      groups.forEach((group, index) => {
        group.open = index == 0;
      });

      groups.forEach((group) => {
        if (group.dataset.mobileToggleBound == 'true') return;
        group.dataset.mobileToggleBound = 'true';

        group.addEventListener('toggle', () => {
          if (!window.matchMedia('(max-width: 992px)').matches) return;
          if (!group.open) return;

          groups.forEach((other) => {
            if (other == group) return;
            other.open = false;
          });
        });
      });
    };

    applyMobileFilterState();
    window.addEventListener('resize', applyMobileFilterState, { passive: true });

    const autoSubmitInputs = form.querySelectorAll('input[type="checkbox"]');
    autoSubmitInputs.forEach((input) => {
      input.addEventListener('change', () => {
        logFilterDebug('checkbox-change-before-submit');
        closeDrawer();
        form.submit();
      });
    });

    const sortSelect = document.getElementById('SortBy');
    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        logFilterDebug('sort-change-before-submit');
        closeDrawer();
        form.submit();
      });
    }

    const grid = document.querySelector('[data-collection-grid]');
    const viewButtons = document.querySelectorAll('.view-btn[data-view]');
    if (mobileView || !grid || viewButtons.length == 0) return;

    const setView = (view) => {
      if (view == 'list') {
        grid.classList.remove('grid-view');
        grid.classList.add('list-view');
      } else {
        grid.classList.remove('list-view');
        grid.classList.add('grid-view');
      }

      viewButtons.forEach((button) => {
        const isActive = button.getAttribute('data-view') == view;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      try {
        localStorage.setItem('collectionViewMode', view);
      } catch (e) {
      }
    };

    viewButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const view = button.getAttribute('data-view');
        setView(view);
      });
    });

    try {
      const savedView = localStorage.getItem('collectionViewMode');
      if (savedView == 'list') {
        setView('list');
      }
    } catch (e) {
    }
  }

  const scheduleCollectionInit = () => {
    // Defer filter/sort wiring to idle time (desktop included) so it doesn't
    // block first interactivity on the collection page. Product links work
    // without it; the filter UI becomes interactive a moment later.
    if ('requestIdleCallback' in window) {
      requestIdleCallback(initCollectionNative, { timeout: 1200 });
    } else {
      setTimeout(initCollectionNative, 300);
    }
  };

  document.addEventListener('DOMContentLoaded', scheduleCollectionInit);
  document.addEventListener('shopify:section:load', scheduleCollectionInit);

  // Open filter groups from the top while the filter CONTENT still fits above the
  // pagination, then collapse the rest -- so the open filters fill the column down
  // to (but not past) the pagination, and nothing makes the page taller than the
  // products. We measure the FORM (#CollectionFiltersForm), whose height is driven
  // by its content. The sidebar <aside> itself is a *stretched* CSS-grid column,
  // so its getBoundingClientRect() always reads the full content-column height --
  // measuring it (the old bug) made collapsing groups never shrink the reading, so
  // it collapsed everything. Done synchronously with the animation suppressed (no
  // expand/collapse flash). Measured after `load` (grid height settled).
  // Desktop column only; mobile = drawer.
  let userToggledFilters = false;
  const fitFilters = () => {
    if (window.matchMedia('(max-width: 992px)').matches) return; // drawer layout: leave to mobile logic
    const sidebar = document.getElementById('CollectionSidebar');
    const form = document.getElementById('CollectionFiltersForm');
    if (!sidebar || !form) return;
    const groups = [...sidebar.querySelectorAll('details.filter-group')];
    if (!groups.length) return;
    const ref = document.querySelector('.pagination') || document.querySelector('.collection__grid');
    const limit = ref ? ref.getBoundingClientRect().bottom : Infinity; // viewport Y of the pagination's bottom
    sidebar.classList.add('is-fitting'); // suppress the expand/collapse animation during this pass
    groups.forEach((g) => { g.open = false; });
    for (let i = 0; i < groups.length; i++) {
      groups[i].open = true; // ...open from the top while the content stays above the pagination...
      if (form.getBoundingClientRect().bottom > limit) { groups[i].open = false; break; }
    }
    if (!groups.some((g) => g.open)) groups[0].open = true; // never leave the panel fully empty
    // Cache this fitted open-state so a history back-nav can replay it before paint
    // (see the inline script at the end of the section markup) -- fitted look, no jump.
    try { sessionStorage.setItem('vtFilterFit:' + location.pathname + location.search, JSON.stringify(groups.map((g) => (g.open ? 1 : 0)))); } catch (e) {}
    requestAnimationFrame(() => sidebar.classList.remove('is-fitting'));
  };
  const runFit = () => { if (!userToggledFilters) requestAnimationFrame(fitFilters); };
  // Once the shopper opens/closes a filter themselves, stop auto-fitting.
  document.addEventListener('click', (e) => {
    if (e.target.closest && e.target.closest('summary.filter-group__title')) userToggledFilters = true;
  }, true);
  // Skip the initial auto-fit on a history (back/forward) navigation. The page is
  // restored at its previous scroll position and a reverse View Transition may be
  // morphing a product card; re-toggling <details> heights here happens AFTER the
  // snapshot / after scroll restore, so the page jumps -- and a viewport-relative
  // measure while scrolled half-way can over-expand filters past the pagination.
  // bfcache restores already keep the fitted state (load doesn't refire); a cold
  // history re-render just keeps the server default. Forward visits + resizes still fit.
  const isHistoryNav = () => {
    try { const n = performance.getEntriesByType('navigation')[0]; return !!n && n.type === 'back_forward'; }
    catch (e) { return false; }
  };
  if (!isHistoryNav()) {
    if (document.readyState === 'complete') runFit();
    else window.addEventListener('load', runFit, { once: true });
  }
  let filterFitTimer;
  window.addEventListener('resize', () => { clearTimeout(filterFitTimer); filterFitTimer = setTimeout(runFit, 200); }, { passive: true });
  document.addEventListener('shopify:section:load', () => { userToggledFilters = false; runFit(); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-header"]) return;
  try {
    
  // Minimal collection header interactions
  document.addEventListener('DOMContentLoaded', function() {
    // Add smooth scroll behavior for anchor links
    const anchorLinks = document.querySelectorAll('.collection-header a[href^="#"]');
    anchorLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        const targetId = this.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);
        
        if (targetElement) {
          const headerOffset = 80;
          const elementPosition = targetElement.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-toolbar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const filterToggle = document.querySelector('.collection-toolbar__filter-toggle');
    const filterPanel = document.getElementById('filter-panel');
    
    if (filterToggle && filterPanel) {
      filterToggle.addEventListener('click', function() {
        const expanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', !expanded);
        filterPanel.hidden = expanded;
      });
    }
    
    const sortSelect = document.getElementById('sort-by');
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        window.location.href = url.toString();
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections"]) return;
  try {
    
  // Minimal collection interactions
  document.addEventListener('DOMContentLoaded', function() {
    const collectionLinks = document.querySelectorAll('.collections__link');
    collectionLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        if (this.closest('.collection.disabled')) {
          e.preventDefault();
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-addresses"]) return;
  try {
    
  function initAddresses() {
    const showAddBtn = document.getElementById('ShowAddAddress');
    const addContainer = document.getElementById('AddAddress');
    const cancelAdd = document.getElementById('CancelAddAddress');

    if (showAddBtn && addContainer) {
      showAddBtn.addEventListener('click', () => {
        addContainer.style.display = 'block';
        showAddBtn.setAttribute('aria-expanded', 'true');
      });
      cancelAdd.addEventListener('click', () => {
        addContainer.style.display = 'none';
        showAddBtn.setAttribute('aria-expanded', 'false');
      });
    }

    // Toggle Edit
    document.querySelectorAll('[id^="EditFormButton_"]').forEach(btn => {
      btn.addEventListener('click', () => {
        const id = btn.getAttribute('data-address-id');
        const container = document.getElementById(`EditAddress_${id}`);
        container.style.display = container.style.display === 'none' ? 'block' : 'none';
      });
    });

    // Delete Address
    document.querySelectorAll('[data-confirm-message]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        if (confirm(e.currentTarget.getAttribute('data-confirm-message'))) {
          const target = e.currentTarget.getAttribute('data-target');
          const form = document.createElement('form');
          form.method = 'post';
          form.action = target;
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = '_method';
          input.value = 'delete';
          form.appendChild(input);
          document.body.appendChild(form);
          form.submit();
        }
      });
    });

    // Country/Province Selector logic
    const countrySelectors = document.querySelectorAll('select[name="address[country]"]');
    countrySelectors.forEach(select => {
      select.addEventListener('change', function() {
        const id = this.getAttribute('id').replace('AddressCountry_', '').replace('AddressCountryNew', 'New');
        const container = document.getElementById(`AddressProvinceContainer_${id}`) || document.getElementById('AddressProvinceContainerNew');
        const provinceSelect = document.getElementById(`AddressProvince_${id}`) || document.getElementById('AddressProvinceNew');
        
        if (!provinceSelect) return;

        const selectedOption = this.options[this.selectedIndex];
        const provinces = JSON.parse(selectedOption.getAttribute('data-provinces'));

        if (provinces && provinces.length > 0) {
          provinceSelect.innerHTML = '';
          provinces.forEach(province => {
            const opt = document.createElement('option');
            opt.value = province[0];
            opt.innerHTML = province[1];
            provinceSelect.appendChild(opt);
          });
          container.style.display = 'block';
        } else {
          container.style.display = 'none';
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initAddresses);
  document.addEventListener('shopify:section:load', initAddresses);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // --- Collection links carry the newest-first sort -----------------------
  // Rewrite bare /collections/<handle> links to include
  // ?sort_by=created-descending on click, so the page loads ONCE already
  // sorted (no client-side redirect / double load). Ungated so it works on
  // every device. Skips links that already have a query string (pagination,
  // filters, an explicit sort) and product URLs, so a chosen sort is never
  // overridden. Direct hits to a bare URL fall back to the admin default sort.
  // Links to another domain (the language switcher hops between the per-language
  // domains) are left alone: rewriting them to a bare path kept the visitor here.
  (function () {
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('a[href]');
      if (!link) return;
      var href = link.getAttribute('href') || '';
      if (href.indexOf('/collections/') === -1 || href.indexOf('?') !== -1) return;
      try {
        var u = new URL(link.href, location.origin);
        if (u.origin !== location.origin) return; // other domain: keep the full URL
        if (u.pathname.indexOf('/products/') !== -1) return; // product page, not a listing
        u.searchParams.set('sort_by', 'created-descending');
        link.setAttribute('href', u.pathname + u.search + u.hash);
      } catch (_) {}
    }, true);
  })();

  // --- Language switcher keeps filters, sort and page ---------------------
  // The cross-domain links are rendered from request.path, which has no query
  // string. Append the current one on click so a filtered collection lands on
  // the same filtered collection on the other domain. The links end in the
  // #wf-lang marker (see language-autoredirect), so the query goes before it.
  (function () {
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('.language-link[href], .sticky-lang-link[href]');
      if (!link || !location.search) return;
      var href = link.getAttribute('href') || '';
      if (href.indexOf('?') !== -1) return;
      var hashAt = href.indexOf('#');
      if (hashAt === -1) {
        link.setAttribute('href', href + location.search);
      } else {
        link.setAttribute('href', href.slice(0, hashAt) + location.search + href.slice(hashAt));
      }
    }, true);
  })();

  // --- Random decorative header pattern (1 of 30) -----------------------
  // Injected at runtime via CSS custom properties so the 30 pattern tiles
  // never sit in the render-blocking CSS — only the chosen one is applied.
  (function () {
    var HP = [
      {s:'44px 44px',u:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='44' height='44'%3E%3Cpath d='M0 22 L22 0 L44 22 L22 44 Z' fill='none' stroke='%23ff8b00' stroke-width='1.1'/%3E%3Cg fill='%23ff8b00'%3E%3Ccircle cx='22' cy='0' r='1.7'/%3E%3Ccircle cx='0' cy='22' r='1.7'/%3E%3Ccircle cx='44' cy='22' r='1.7'/%3E%3Ccircle cx='22' cy='44' r='1.7'/%3E%3Ccircle cx='22' cy='22' r='1.5'/%3E%3C/g%3E%3C/svg%3E"},
      {s:'40px 40px',u:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40'%3E%3Cg fill='none' stroke='%23ff8b00' stroke-width='1.1'%3E%3Ccircle cx='0' cy='0' r='20'/%3E%3Ccircle cx='40' cy='0' r='20'/%3E%3Ccircle cx='0' cy='40' r='20'/%3E%3Ccircle cx='40' cy='40' r='20'/%3E%3Ccircle cx='20' cy='20' r='20'/%3E%3C/g%3E%3C/svg%3E"},
      {s:'40px 20px',u:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='20'%3E%3Cpath d='M0 14 L10 4 L20 14 L30 4 L40 14' fill='none' stroke='%23ff8b00' stroke-width='1.4'/%3E%3C/svg%3E"},
      {s:'28px 28px',u:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='28' height='28'%3E%3Cg fill='none' stroke='%23ff8b00' stroke-width='1.1'%3E%3Ccircle cx='14' cy='14' r='9'/%3E%3C/g%3E%3Cg fill='%23ff8b00'%3E%3Ccircle cx='14' cy='14' r='1.5'/%3E%3Ccircle cx='0' cy='0' r='1.5'/%3E%3Ccircle cx='28' cy='0' r='1.5'/%3E%3Ccircle cx='0' cy='28' r='1.5'/%3E%3Ccircle cx='28' cy='28' r='1.5'/%3E%3C/g%3E%3C/svg%3E"},
      {s:'40px 40px',u:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40'%3E%3Cpath d='M0 0 H40 M0 20 H40 M0 0 V20 M40 0 V20 M20 20 V40' fill='none' stroke='%23ff8b00' stroke-width='1.1'/%3E%3C/svg%3E"},
      {s:'48px 48px',u:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48' height='48'%3E%3Cg fill='none' stroke='%23ff8b00' stroke-width='1.1'%3E%3Ccircle cx='24' cy='24' r='15'/%3E%3Ccircle cx='24' cy='24' r='7'/%3E%3Cpath d='M24 9 V39 M9 24 H39'/%3E%3C/g%3E%3Cg fill='%23ff8b00'%3E%3Ccircle cx='24' cy='24' r='1.6'/%3E%3Ccircle cx='0' cy='0' r='2'/%3E%3Ccircle cx='48' cy='0' r='2'/%3E%3Ccircle cx='0' cy='48' r='2'/%3E%3Ccircle cx='48' cy='48' r='2'/%3E%3C/g%3E%3C/svg%3E"},
      {s:'24px 24px',u:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24'%3E%3Cpath d='M12 7 V17 M7 12 H17 M0 0 V5 M0 0 H5 M24 0 V5 M24 0 H19 M0 24 V19 M0 24 H5 M24 24 V19 M24 24 H19' fill='none' stroke='%23ff8b00' stroke-width='1.1'/%3E%3C/svg%3E"},
      {s:'22px 22px',u:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='22' height='22'%3E%3Cg fill='%23ff8b00'%3E%3Ccircle cx='11' cy='11' r='1.8'/%3E%3Ccircle cx='0' cy='0' r='1.8'/%3E%3Ccircle cx='22' cy='0' r='1.8'/%3E%3Ccircle cx='0' cy='22' r='1.8'/%3E%3Ccircle cx='22' cy='22' r='1.8'/%3E%3C/g%3E%3C/svg%3E"},
      {s:'40px 20px',u:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='20'%3E%3Cpath d='M0 10 Q 10 2 20 10 T 40 10' fill='none' stroke='%23ff8b00' stroke-width='1.3'/%3E%3C/svg%3E"},
      {s:'40px 40px',u:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40'%3E%3Cpath d='M12 0 L28 0 L40 12 L40 28 L28 40 L12 40 L0 28 L0 12 Z' fill='none' stroke='%23ff8b00' stroke-width='1.1'/%3E%3C/svg%3E"},
      {s:'40px 40px',u:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40'%3E%3Cg fill='none' stroke='%23ff8b00' stroke-width='1.1'%3E%3Ccircle cx='20' cy='11' r='10'/%3E%3Ccircle cx='20' cy='29' r='10'/%3E%3Ccircle cx='11' cy='20' r='10'/%3E%3Ccircle cx='29' cy='20' r='10'/%3E%3C/g%3E%3C/svg%3E"},
      {s:'40px 40px',u:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40'%3E%3Cg fill='none' stroke='%23ff8b00' stroke-width='1.1'%3E%3Crect x='5' y='5' width='30' height='30'/%3E%3Crect x='13' y='13' width='14' height='14'/%3E%3C/g%3E%3Ccircle cx='20' cy='20' r='1.6' fill='%23ff8b00'/%3E%3C/svg%3E"},
      {s:'30px 36px',u:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='30' height='36'%3E%3Cpath d='M0 36 L0 18 Q 10 2 15 0 Q 20 2 30 18 L30 36' fill='none' stroke='%23ff8b00' stroke-width='1.1'/%3E%3C/svg%3E"},
      {s:'32px 32px',u:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32'%3E%3Cg fill='none' stroke='%23ff8b00' stroke-width='1.1'%3E%3Crect x='6' y='6' width='20' height='20'/%3E%3Cpath d='M16 0 V6 M16 26 V32 M0 16 H6 M26 16 H32'/%3E%3C/g%3E%3C/svg%3E"},
      {s:'18px 18px',u:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18'%3E%3Cpath d='M0 18 L18 0 M0 0 L18 18' fill='none' stroke='%23ff8b00' stroke-width='0.9'/%3E%3C/svg%3E"},
      {s:'40px 35px',u:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='35'%3E%3Cpath d='M0 35 L20 0 L40 35 Z' fill='none' stroke='%23ff8b00' stroke-width='1.1'/%3E%3C/svg%3E"},
      {s:'20px 12px',u:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='12'%3E%3Cpath d='M0 0 A 10 10 0 0 0 20 0' fill='none' stroke='%23ff8b00' stroke-width='1.1'/%3E%3C/svg%3E"},
      {s:'40px 40px',u:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40'%3E%3Cpath d='M2 7 H18 M2 13 H18 M27 2 V18 M33 2 V18 M7 22 V38 M13 22 V38 M22 27 H38 M22 33 H38' fill='none' stroke='%23ff8b00' stroke-width='1.1'/%3E%3C/svg%3E"},
      {s:'12px 12px',u:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12'%3E%3Cpath d='M0 12 L12 0' fill='none' stroke='%23ff8b00' stroke-width='1.1'/%3E%3C/svg%3E"},
      {s:'20px 40px',u:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='40'%3E%3Cpath d='M10 0 Q 2 10 10 20 Q 18 30 10 40' fill='none' stroke='%23ff8b00' stroke-width='1.3'/%3E%3C/svg%3E"},
      {s:'40px 40px',u:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40'%3E%3Cg fill='none' stroke='%23ff8b00' stroke-width='1.1'%3E%3Ccircle cx='20' cy='20' r='16'/%3E%3Ccircle cx='20' cy='20' r='10'/%3E%3Ccircle cx='20' cy='20' r='4'/%3E%3C/g%3E%3Cg fill='%23ff8b00'%3E%3Ccircle cx='0' cy='0' r='1.5'/%3E%3Ccircle cx='40' cy='0' r='1.5'/%3E%3Ccircle cx='0' cy='40' r='1.5'/%3E%3Ccircle cx='40' cy='40' r='1.5'/%3E%3C/g%3E%3C/svg%3E"},
      {s:'20px 16px',u:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='16'%3E%3Cpath d='M0 4 H6 V12 H14 V4 H20' fill='none' stroke='%23ff8b00' stroke-width='1.2'/%3E%3C/svg%3E"},
      {s:'20px 20px',u:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20'%3E%3Cpath d='M0 0 H20 M0 0 V20' fill='none' stroke='%23ff8b00' stroke-width='1'/%3E%3Ccircle cx='10' cy='10' r='1.5' fill='%23ff8b00'/%3E%3C/svg%3E"},
      {s:'40px 40px',u:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40'%3E%3Cpath d='M20 0 L40 20 L20 40 L0 20 Z' fill='none' stroke='%23ff8b00' stroke-width='1'/%3E%3Cpath d='M0 0 L40 40 M40 0 L0 40' fill='none' stroke='%23ff8b00' stroke-width='0.8' stroke-dasharray='2 3'/%3E%3C/svg%3E"},
      {s:'20px 12px',u:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='12'%3E%3Cpath d='M0 12 L20 0 L20 12' fill='none' stroke='%23ff8b00' stroke-width='1.2'/%3E%3C/svg%3E"},
      {s:'12px 8px',u:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8'%3E%3Cpath d='M0 0 V8 M6 0 V8' fill='none' stroke='%23ff8b00' stroke-width='1'/%3E%3C/svg%3E"},
      {s:'18px 18px',u:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18'%3E%3Cpath d='M0 18 L18 0 M0 0 L18 18' fill='none' stroke='%23ff8b00' stroke-width='0.8'/%3E%3Ccircle cx='9' cy='9' r='3' fill='none' stroke='%23ff8b00' stroke-width='0.8'/%3E%3C/svg%3E"},
      {s:'16px 16px',u:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3E%3Cpath d='M4 4 L12 12 M12 4 L4 12' fill='none' stroke='%23ff8b00' stroke-width='1.1'/%3E%3C/svg%3E"},
      {s:'40px 40px',u:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40'%3E%3Cg fill='none' stroke='%23ff8b00' stroke-width='1.1'%3E%3Cpath d='M20 2 L38 20 L20 38 L2 20 Z'/%3E%3Cpath d='M20 12 L28 20 L20 28 L12 20 Z'/%3E%3C/g%3E%3Ccircle cx='20' cy='20' r='1.5' fill='%23ff8b00'/%3E%3C/svg%3E"},
      {s:'24px 24px',u:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24'%3E%3Cg fill='%23ff8b00'%3E%3Ccircle cx='12' cy='12' r='2.4'/%3E%3Ccircle cx='0' cy='0' r='1.2'/%3E%3Ccircle cx='24' cy='0' r='1.2'/%3E%3Ccircle cx='0' cy='24' r='1.2'/%3E%3Ccircle cx='24' cy='24' r='1.2'/%3E%3Ccircle cx='12' cy='0' r='1.2'/%3E%3Ccircle cx='0' cy='12' r='1.2'/%3E%3Ccircle cx='24' cy='12' r='1.2'/%3E%3Ccircle cx='12' cy='24' r='1.2'/%3E%3C/g%3E%3C/svg%3E"},
    ];
    function applyHeaderPattern() {
      var h = document.querySelector('.main-header');
      if (!h) return;
      var p = HP[Math.floor(Math.random() * HP.length)];
      h.style.setProperty('--hp-img', 'url("' + p.u + '")');
      h.style.setProperty('--hp-size', p.s);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyHeaderPattern);
    } else {
      applyHeaderPattern();
    }
  })();
  function initHeader() {
    const headerRoot = document.getElementById('HeaderWrapper');
    if (!headerRoot) return;
    if (headerRoot.dataset.initialized === 'true') return;
    headerRoot.dataset.initialized = 'true';

    // Pause the announcement banner's infinite animations while it is scrolled
    // out of view (see the CSS note next to .announcement-banner.is-offscreen).
    const announcement = document.getElementById('AnnouncementBanner');
    if (announcement && 'IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        entries.forEach((entry) => announcement.classList.toggle('is-offscreen', !entry.isIntersecting));
      }).observe(announcement);
    }

    const body = document.body;
    const wrapper = document.getElementById('SearchWrapper');
    const input = document.getElementById('HeaderSearchInput');
    const closeBtn = document.getElementById('SearchCloseBtn');
    const backdrop = document.getElementById('SearchBackdrop');
    const resultsContainer = document.getElementById('HeaderSearchResults');
    const mobileSearchToggle = document.getElementById('MobileSearchToggle');
    const searchContainer = document.querySelector('.main-header__search');

    // --- Search open/close as a FLIP transition --------------------------
    // The bar expands from its current spot (or, on mobile, the tapped search
    // icon) into the centred overlay, instead of sliding in from the edge.
    let searchFirstRect = null;
    let searchCloseTimer = null;
    const FLIP_MS = 420;
    const FLIP_EASE = 'cubic-bezier(0.16, 0.84, 0.44, 1)';
    const flipTransition = `top ${FLIP_MS}ms ${FLIP_EASE}, left ${FLIP_MS}ms ${FLIP_EASE}, width ${FLIP_MS}ms ${FLIP_EASE}`;

    const overlayGeometry = () => {
      const vw = window.innerWidth;
      const isMobile = vw <= 768;
      const margin = isMobile ? 20 : 40;
      let width = vw - margin;
      if (!isMobile) width = Math.min(width, 800);
      return { top: isMobile ? 10 : 60, left: (vw - width) / 2, width: width };
    };

    // Where the animation starts: the visible search bar, or (when it's hidden
    // on mobile) the trigger icon that was tapped.
    const originRect = (e) => {
      const r = wrapper.getBoundingClientRect();
      const inView = r.width > 1 && r.height > 1 && r.bottom > 0 && r.top < window.innerHeight;
      if (inView) return { top: r.top, left: r.left, width: r.width };
      const trigger = (e && e.currentTarget && e.currentTarget.getBoundingClientRect) ? e.currentTarget : mobileSearchToggle;
      if (trigger && trigger.getBoundingClientRect) {
        const t = trigger.getBoundingClientRect();
        return { top: t.top, left: t.left, width: t.width };
      }
      return { top: r.top, left: r.left, width: r.width };
    };

    const setWrapperRect = (rect) => {
      wrapper.style.top = rect.top + 'px';
      wrapper.style.left = rect.left + 'px';
      wrapper.style.width = rect.width + 'px';
    };

    const openSearch = (e) => {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      if (wrapper.classList.contains('is-active')) return;
      if (searchCloseTimer) { clearTimeout(searchCloseTimer); searchCloseTimer = null; }
      searchFirstRect = originRect(e);
      body.classList.add('search-active');
      wrapper.classList.remove('is-closing');
      wrapper.classList.add('is-active');
      if (window.innerWidth <= 768) searchContainer.classList.add('is-searching-mobile');
      // Start pinned to the origin, then animate to the overlay (FLIP).
      wrapper.style.transition = 'none';
      setWrapperRect(searchFirstRect);
      void wrapper.offsetWidth; // lock in the start frame
      wrapper.style.transition = flipTransition;
      setWrapperRect(overlayGeometry());
      setTimeout(() => input.focus(), FLIP_MS * 0.35);
    };

    const finishCloseSearch = () => {
      wrapper.classList.remove('is-active');
      wrapper.classList.remove('is-closing');
      body.classList.remove('search-active');
      if (searchContainer) searchContainer.classList.remove('is-searching-mobile');
      wrapper.style.transition = '';
      wrapper.style.top = '';
      wrapper.style.left = '';
      wrapper.style.width = '';
      resultsContainer.innerHTML = '';
      searchCloseTimer = null;
    };

    const closeSearch = () => {
      if (!wrapper.classList.contains('is-active')) { input.value = ''; return; }
      input.value = '';
      input.blur();
      wrapper.classList.add('is-closing'); // results fade out + close button drops immediately, not riding the bar
      // FLIP back to the origin, then tear down the overlay.
      wrapper.style.transition = flipTransition;
      setWrapperRect(searchFirstRect || originRect());
      if (searchCloseTimer) clearTimeout(searchCloseTimer);
      searchCloseTimer = setTimeout(finishCloseSearch, FLIP_MS + 40);
    };

    if(input) { input.onfocus = openSearch; input.onclick = (e) => e.stopPropagation(); }
    if(mobileSearchToggle) mobileSearchToggle.onclick = openSearch;
    if(closeBtn) closeBtn.onclick = closeSearch;
    if(backdrop) backdrop.onclick = closeSearch;

    document.addEventListener('keydown', (e) => { if(e.key === 'Escape') closeSearch(); });

    // Keep the open overlay centred if the viewport changes (e.g. rotation).
    window.addEventListener('resize', () => {
      if (wrapper.classList.contains('is-active') && !searchCloseTimer) {
        wrapper.style.transition = 'none';
        setWrapperRect(overlayGeometry());
      }
    }, { passive: true });

    let timer;
    let searchSeq = 0;
    const suggestBase = (window.WFSearchConfig && window.WFSearchConfig.suggest) || '/search/suggest';
    const fetchSuggest = (q) =>
      fetch(`${suggestBase}?q=${encodeURIComponent(q)}&resources[type]=product,collection,page,article&resources[options][fields]=title,body,vendor,product_type,variants.sku&section_id=predictive-search`)
        .then(r => r.text())
        .then(html => new DOMParser().parseFromString(html, 'text/html').querySelector('#predictive-search-results'));
    const hasHits = (res) => !!(res && res.querySelector('.predictive-search__item'));
    const showResults = (res, correctedTerm) => {
      resultsContainer.innerHTML = res ? res.innerHTML : '';
      if (res && correctedTerm) {
        // The user's literal query had no hits; these results come from the
        // fuzzy-corrected query, so say which query is being shown.
        const note = document.createElement('div');
        note.className = 'search-corrected-note';
        const tpl = resultsContainer.getAttribute('data-corrected-label') || 'Results for "%s"';
        note.textContent = tpl.replace('%s', correctedTerm);
        resultsContainer.prepend(note);
      }
    };
    if(input) {
      input.oninput = () => {
        clearTimeout(timer);
        const q = input.value.trim();
        if(q.length < 2) { resultsContainer.innerHTML = ''; return; }
        timer = setTimeout(() => {
          const seq = ++searchSeq;
          fetchSuggest(q).then(res => {
            if (seq !== searchSeq) return;
            if (hasHits(res) || !window.WFFuzzySearch) { showResults(res); return; }
            // Nothing found: try a space-agnostic / typo-tolerant correction
            // and re-run the suggestion with the corrected query.
            window.WFFuzzySearch.correct(q).then(corrected => {
              if (seq !== searchSeq) return;
              if (!corrected) { showResults(res); return; }
              fetchSuggest(corrected).then(res2 => {
                if (seq !== searchSeq) return;
                if (hasHits(res2)) showResults(res2, corrected);
                else showResults(res);
              });
            });
          }).catch(() => {});
        }, 300);
      };
    }

    const langBtn = document.getElementById('LangBtn');
    const langList = document.getElementById('LangList');
    if(langBtn) {
      langBtn.onclick = (e) => { e.stopPropagation(); langList.classList.toggle('is-open'); };
      langList.querySelectorAll('.language-link[data-value]').forEach(link => {
        link.onclick = function(e) {
          e.preventDefault();
          const val = this.getAttribute('data-value');
          if (val) {
            document.getElementById('LocaleCode').value = val;
            var form = document.getElementById('HeaderLanguageForm');
            var back = form.querySelector('input[name="return_to"]');
            if (back) back.value = location.pathname + location.search;
            form.submit();
          }
        };
      });
      document.addEventListener('click', () => langList?.classList.remove('is-open'));
    }

    const mToggle = document.getElementById('MobileMenuToggle');
    const mDrawer = document.getElementById('MobileDrawer');
    const mOverlay = document.getElementById('MobileOverlay');
    if(mToggle) mToggle.onclick = () => { mDrawer.classList.add('is-active'); mOverlay.classList.add('is-active'); body.style.overflow = 'hidden'; };
    [document.getElementById('MobileDrawerClose'), mOverlay].forEach(el => { if(el) el.onclick = () => { mDrawer.classList.remove('is-active'); mOverlay.classList.remove('is-active'); body.style.overflow = ''; }; });

    // Sticky header scroll logic
    const stickyHeader = document.getElementById('StickyHeader');
    const mobileStickyHeader = document.getElementById('MobileStickyHeader');
    const stickySearchBtn = document.getElementById('StickySearchBtn');
    if (stickyHeader || mobileStickyHeader) {
      let ticking = false;
      const threshold = headerRoot.offsetHeight;

      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          const scrollY = window.scrollY;
          const past = scrollY > threshold;
          if (stickyHeader) {
            stickyHeader.classList.toggle('is-visible', past);
            if (past) stickyHeader.removeAttribute('inert'); else stickyHeader.setAttribute('inert', '');
          }
          if (mobileStickyHeader) {
            mobileStickyHeader.classList.toggle('is-visible', past);
            if (past) mobileStickyHeader.removeAttribute('inert'); else mobileStickyHeader.setAttribute('inert', '');
          }
          ticking = false;
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });

      if (stickySearchBtn) {
        stickySearchBtn.addEventListener('click', (e) => { openSearch(e); });
      }
    }

    // Sticky header language selector
    const stickyLangBtn = document.getElementById('StickyLangBtn');
    const stickyLangList = document.getElementById('StickyLangList');
    if (stickyLangBtn && stickyLangList) {
      stickyLangBtn.onclick = (e) => { e.stopPropagation(); stickyLangList.classList.toggle('is-open'); };
      stickyLangList.querySelectorAll('.sticky-lang-link[data-value]').forEach(link => {
        link.onclick = function(e) {
          e.preventDefault();
          const val = this.getAttribute('data-value');
          if (val) {
            document.getElementById('StickyLocaleCode').value = val;
            var form = document.getElementById('StickyLangForm');
            var back = form.querySelector('input[name="return_to"]');
            if (back) back.value = location.pathname + location.search;
            form.submit();
          }
        };
      });
      document.addEventListener('click', () => stickyLangList.classList.remove('is-open'));
    }

    // Mobile sticky header controls
    const mobileStickyMenuToggle = document.getElementById('MobileStickyMenuToggle');
    if (mobileStickyMenuToggle) {
      mobileStickyMenuToggle.onclick = () => {
        const drawer = document.getElementById('MobileDrawer');
        const overlay = document.getElementById('MobileOverlay');
        if (drawer) { drawer.classList.add('is-active'); overlay?.classList.add('is-active'); body.style.overflow = 'hidden'; }
      };
    }

    const mobileStickySearchBtn = document.getElementById('MobileStickySearchBtn');
    if (mobileStickySearchBtn) {
      mobileStickySearchBtn.addEventListener('click', (e) => { openSearch(e); });
    }

    const mobileStickyLangBtn = document.getElementById('MobileStickyLangBtn');
    const mobileStickyLangList = document.getElementById('MobileStickyLangList');
    if (mobileStickyLangBtn && mobileStickyLangList) {
      mobileStickyLangBtn.onclick = (e) => { e.stopPropagation(); mobileStickyLangList.classList.toggle('is-open'); };
      mobileStickyLangList.querySelectorAll('.sticky-lang-link[data-value]').forEach(link => {
        link.onclick = function(e) {
          e.preventDefault();
          const val = this.getAttribute('data-value');
          if (val) {
            document.getElementById('MobileStickyLocaleCode').value = val;
            var form = document.getElementById('MobileStickyLangForm');
            var back = form.querySelector('input[name="return_to"]');
            if (back) back.value = location.pathname + location.search;
            form.submit();
          }
        };
      });
      document.addEventListener('click', () => mobileStickyLangList.classList.remove('is-open'));
    }

    const drawerToggles = document.querySelectorAll('.drawer-submenu-toggle');
    drawerToggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const row = toggle.closest('.drawer-link-row');
        if (!row) return;
        const item = row.parentElement;
        if (!item) return;
        const submenu = item.querySelector('.drawer-submenu');
        if (!submenu) return;

        const isOpen = toggle.classList.contains('is-open');
        if (isOpen) {
          toggle.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
          submenu.hidden = true;
        } else {
          drawerToggles.forEach((otherToggle) => {
            if (otherToggle === toggle) return;
            const otherRow = otherToggle.closest('.drawer-link-row');
            if (!otherRow) return;
            const otherItem = otherRow.parentElement;
            if (!otherItem) return;
            const otherSubmenu = otherItem.querySelector('.drawer-submenu');
            if (!otherSubmenu) return;
            otherToggle.classList.remove('is-open');
            otherToggle.setAttribute('aria-expanded', 'false');
            otherSubmenu.hidden = true;
          });

          toggle.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
          submenu.hidden = false;

          try {
            item.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          } catch (e) {
          }
        }
      });
    });
    
  }
  // Defer header wiring (it includes an offsetHeight reflow) to idle so it
  // doesn't block first interactivity or contend with a page transition.
  var bootHeader = function () {
    if ('requestIdleCallback' in window) requestIdleCallback(initHeader, { timeout: 300 });
    else setTimeout(initHeader, 50);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootHeader);
  else bootHeader();
  document.addEventListener('shopify:section:load', initHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SECTION_SELECTOR = '.hero[data-hero-three="true"]';
    const instances = new WeakMap();

    const loadThree = (moduleUrl) => {
      if (window.THREE) return Promise.resolve(window.THREE);
      if (window.__threeLoadPromise) return window.__threeLoadPromise;

      const sourceUrl = moduleUrl || '/assets/three.module.min.js';

      window.__threeLoadPromise = new Promise((resolve, reject) => {
        import(sourceUrl)
          .then((module) => {
            if (module && module.Scene) {
              resolve(module);
              return;
            }

            if (module && module.default && module.default.Scene) {
              resolve(module.default);
              return;
            }

            throw new Error('Invalid Three.js module export');
          })
          .catch(() => {
            reject(new Error('Unable to load local Three.js module'));
          });
      });

      return window.__threeLoadPromise;
    };

    const isReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isMobile = () => window.matchMedia('(max-width: 768px)').matches;

    const resolveQuality = (mobileQuality) => {
      if (!isMobile()) return 'desktop';
      return 'off';
    };

    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    // Hand control back to the browser between chunks of the heavy WebGL init
    // so it can paint and service input/scroll (uses scheduler.yield where
    // available, falling back to a macrotask).
    const yieldToMain = () => (window.scheduler && window.scheduler.yield)
      ? window.scheduler.yield()
      : new Promise((resolve) => setTimeout(resolve, 0));

    const initScene = async (section) => {
      if (instances.has(section)) return;
      if (isReducedMotion()) return;

      const quality = resolveQuality(section.dataset.heroMobileQuality || 'low');
      if (quality === 'off') return;

      const canvas = section.querySelector('.hero__fx-canvas');
      if (!canvas) return;

      try {
        const THREE = await loadThree(section.dataset.threeModuleUrl);
        // Split the Three.js parse and the WebGL build into separate tasks so
        // the main thread can service input/scroll between them.
        await yieldToMain();
        const effectMode = section.dataset.heroEffect || 'embers';
        const heroVariant = section.dataset.heroVariant || 'home';
        const isAboutVariant = heroVariant === 'about';
        const intensity = clamp(Number(section.dataset.heroIntensity || 60), 20, 100) / 100;
        const mobileView = isMobile();
        const useParallax = section.dataset.heroParallax === 'true' && !mobileView;
        const reducedPerformance = quality === 'low' || mobileView;

        const scene = new THREE.Scene();
        const camera = new THREE.PerspectiveCamera(48, 1, 0.1, 140);
        camera.position.set(0, 0.25, 9.5);

        const renderer = new THREE.WebGLRenderer({
          canvas,
          alpha: true,
          antialias: quality !== 'low',
          powerPreference: 'low-power'
        });

        if (!renderer.getContext()) {
          section.classList.add('hero--fx-fallback');
          renderer.dispose();
          return;
        }

        renderer.setClearColor(0x000000, 0);
        renderer.outputColorSpace = THREE.SRGBColorSpace;

        const pixelCap = isMobile() ? (quality === 'medium' ? 1.3 : 1.1) : 1.6;
        renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, pixelCap));

        await yieldToMain();
        const root = new THREE.Group();
        scene.add(root);

        let colorCoreHex = 0xff822e;
        let colorEdgeHex = 0xffbc78;
        if (isAboutVariant) {
          colorCoreHex = 0x6faee8;
          colorEdgeHex = 0xd6ecff;
        }
        if (effectMode === 'arcane') {
          colorCoreHex = 0x68b5ff;
          colorEdgeHex = 0xaddaff;
        } else if (effectMode === 'mist') {
          colorCoreHex = 0xced7e0;
          colorEdgeHex = 0xedf3f8;
        }

        scene.add(new THREE.AmbientLight(colorEdgeHex, effectMode === 'mist' ? 0.44 : 0.34));

        const fireLight = new THREE.PointLight(colorCoreHex, effectMode === 'arcane' ? 0.7 : 1.05, 28, 2);
        fireLight.position.set(0, 1.2, 6.4);
        scene.add(fireLight);

        const edgeLight = new THREE.PointLight(colorEdgeHex, 0.32, 22, 2);
        edgeLight.position.set(-2.8, 1.7, 5.5);
        scene.add(edgeLight);

        const gemMaterial = reducedPerformance
          ? new THREE.MeshStandardMaterial({
              color: colorCoreHex,
              roughness: 0.2,
              metalness: 0.12,
              transparent: true,
              opacity: effectMode === 'mist' ? 0.28 : (isAboutVariant ? 0.5 : 0.44),
              emissive: colorCoreHex,
              emissiveIntensity: effectMode === 'mist' ? 0.04 : (isAboutVariant ? 0.1 : 0.08)
            })
          : new THREE.MeshPhysicalMaterial({
          color: colorCoreHex,
          roughness: 0.08,
          metalness: 0.06,
          transmission: effectMode === 'mist' ? 0.35 : (isAboutVariant ? 0.72 : 0.62),
          thickness: 0.8,
          clearcoat: 1,
          clearcoatRoughness: 0.12,
          transparent: true,
          opacity: effectMode === 'mist' ? 0.34 : (isAboutVariant ? 0.6 : 0.54),
          emissive: colorCoreHex,
          emissiveIntensity: effectMode === 'mist' ? 0.05 : (isAboutVariant ? 0.16 : 0.11)
        });

        const metalMaterial = new THREE.MeshStandardMaterial({
          color: effectMode === 'arcane' ? 0x8aa3bf : 0x7a6045,
          roughness: 0.3,
          metalness: 0.85,
          transparent: true,
          opacity: effectMode === 'mist' ? 0.28 : 0.46
        });

        const diceWire = new THREE.MeshBasicMaterial({
          color: colorEdgeHex,
          transparent: true,
          opacity: effectMode === 'mist' ? 0.3 : 0.5,
          wireframe: true
        });

        const makeDie = (geometry, posX, posY, posZ, scale, style) => {
          const group = new THREE.Group();
          const solid = new THREE.Mesh(geometry, style === 'metal' ? metalMaterial : gemMaterial);
          const wire = new THREE.Mesh(geometry, diceWire);
          const wireBold = new THREE.Mesh(geometry, diceWire);
          wireBold.scale.setScalar(1.02);
          group.add(solid);
          group.add(wire);
          group.add(wireBold);
          group.position.set(posX, posY, posZ);
          group.scale.setScalar(scale);
          root.add(group);
          return group;
        };

        const dieD12 = makeDie(new THREE.DodecahedronGeometry(1), -3.3, -2.2, -1.7, 0.72, 'gem');
        const dieD20 = makeDie(new THREE.IcosahedronGeometry(1), 3.4, -2.1, -1.3, 0.63, 'metal');
        const dieD8 = makeDie(new THREE.OctahedronGeometry(1), 1.95, -2.55, -2.1, 0.52, 'gem');

        const dieLayouts = {
          desktop: {
            d12: heroVariant === 'about' ? { ax: 0.1, ay: 0.18, z: -1.9, s: 0.58 } : { ax: 0.12, ay: 0.2, z: -2.1, s: 0.62 },
            d20: heroVariant === 'about' ? { ax: 0.9, ay: 0.2, z: -1.7, s: 0.54 } : { ax: 0.88, ay: 0.2, z: -1.9, s: 0.58 },
            d8: heroVariant === 'about' ? { ax: 0.86, ay: 0.8, z: -2.2, s: 0.42 } : { ax: 0.14, ay: 0.78, z: -2.4, s: 0.46 }
          },
          mobile: {
            d12: heroVariant === 'about' ? { ax: 0.12, ay: 0.14, z: -1.7, s: 0.39 } : { ax: 0.1, ay: 0.14, z: -1.75, s: 0.42 },
            d20: heroVariant === 'about' ? { ax: 0.88, ay: 0.24, z: -1.6, s: 0.38 } : { ax: 0.9, ay: 0.28, z: -1.65, s: 0.41 },
            d8: heroVariant === 'about' ? { ax: 0.84, ay: 0.84, z: -2, s: 0.34 } : { ax: 0.14, ay: 0.82, z: -2.05, s: 0.38 }
          }
        };

        const dieBaseY = {
          d12: dieLayouts.desktop.d12.y,
          d20: dieLayouts.desktop.d20.y,
          d8: dieLayouts.desktop.d8.y
        };

        const dieBaseX = {
          d12: 0,
          d20: 0,
          d8: 0
        };

        const dieParallax = {
          d12: { x: 0, y: 0 },
          d20: { x: 0, y: 0 },
          d8: { x: 0, y: 0 }
        };

        const dieBobAmp = {
          d12: 0.08,
          d20: 0.07,
          d8: 0.06
        };

        const applyDieLayout = () => {
          const mobileView = window.matchMedia('(max-width: 768px)').matches;
          const layout = mobileView ? dieLayouts.mobile : dieLayouts.desktop;
          const heightBoost = clamp(760 / Math.max(height || 760, 420), 1, 1.55);

          const computeAmp = (cfg, baseAmp) => {
            const positionBoost = cfg.ay >= 0.72 ? 1.25 : (cfg.ay >= 0.5 ? 1.1 : 1);
            return baseAmp * heightBoost * positionBoost;
          };

          const toWorldPosition = (cfg) => {
            const anchorX = clamp(cfg.ax, 0.08, 0.92);
            const anchorY = clamp(cfg.ay, 0.08, 0.92);
            const distance = camera.position.z - cfg.z;
            const viewHeight = 2 * Math.tan((camera.fov * Math.PI) / 360) * distance;
            const viewWidth = viewHeight * camera.aspect;

            return {
              x: (anchorX - 0.5) * viewWidth,
              y: (0.5 - anchorY) * viewHeight,
              z: cfg.z
            };
          };

          const d12Pos = toWorldPosition(layout.d12);
          const d20Pos = toWorldPosition(layout.d20);
          const d8Pos = toWorldPosition(layout.d8);

          dieD12.position.set(d12Pos.x, d12Pos.y, d12Pos.z);
          dieD12.scale.setScalar(layout.d12.s);
          dieBaseX.d12 = d12Pos.x;
          dieBaseY.d12 = d12Pos.y;
          dieBobAmp.d12 = computeAmp(layout.d12, 0.08);

          dieD20.position.set(d20Pos.x, d20Pos.y, d20Pos.z);
          dieD20.scale.setScalar(layout.d20.s);
          dieBaseX.d20 = d20Pos.x;
          dieBaseY.d20 = d20Pos.y;
          dieBobAmp.d20 = computeAmp(layout.d20, 0.07);

          dieD8.position.set(d8Pos.x, d8Pos.y, d8Pos.z);
          dieD8.scale.setScalar(layout.d8.s);
          dieBaseX.d8 = d8Pos.x;
          dieBaseY.d8 = d8Pos.y;
          dieBobAmp.d8 = computeAmp(layout.d8, 0.06);
        };

        const emberCountBase = isAboutVariant
          ? (quality === 'medium' ? 110 : 60)
          : (quality === 'medium' ? 140 : 80);
        const emberCount = Math.round(emberCountBase * intensity);
        const positions = new Float32Array(emberCount * 3);
        const speeds = new Float32Array(emberCount);
        const drift = new Float32Array(emberCount);

        for (let i = 0; i < emberCount; i += 1) {
          const i3 = i * 3;
          positions[i3] = (Math.random() - 0.5) * (isAboutVariant ? 16 : 14);
          positions[i3 + 1] = (Math.random() * (isAboutVariant ? 8 : 6)) - (isAboutVariant ? 4 : 4.4);
          positions[i3 + 2] = (Math.random() - 0.5) * (isAboutVariant ? 10 : 7);
          speeds[i] = isAboutVariant ? (0.0012 + Math.random() * 0.0032) : (0.004 + Math.random() * 0.012);
          drift[i] = (Math.random() - 0.5) * (isAboutVariant ? 0.004 : 0.0012);
        }

        const emberGeometry = new THREE.BufferGeometry();
        emberGeometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));
        emberGeometry.attributes.position.setUsage(THREE.DynamicDrawUsage);

        const emberMaterial = new THREE.PointsMaterial({
          color: isAboutVariant ? 0xd9efff : colorEdgeHex,
          size: isAboutVariant ? 0.18 : (effectMode === 'mist' ? 0.08 : 0.11),
          transparent: true,
          opacity: isAboutVariant ? 0.2 : (effectMode === 'mist' ? 0.18 : 0.48),
          depthWrite: false,
          blending: isAboutVariant ? THREE.NormalBlending : THREE.AdditiveBlending
        });

        const embers = new THREE.Points(emberGeometry, emberMaterial);
        root.add(embers);

        const glintLight = new THREE.PointLight(0xe7f4ff, isAboutVariant ? 0.78 : 0.2, 18, 2);
        glintLight.position.set(0.8, -0.6, 4.2);
        root.add(glintLight);

        const pointer = { x: 0, y: 0 };
        let rafId = 0;
        let running = true;
        let active = true;
        let time = 0;
        let width = 0;
        let height = 0;
        let lastFrame = 0;
        const targetFrame = mobileView ? (1000 / 24) : (reducedPerformance ? (1000 / 30) : (1000 / 45));
        let mobileResizeTimer = null;

        const resize = () => {
          width = canvas.clientWidth;
          height = canvas.clientHeight;
          if (!width || !height) return;
          renderer.setSize(width, height, false);
          camera.aspect = width / height;
          camera.position.z = width < 768 ? 8.6 : 9.5;
          camera.updateProjectionMatrix();
          applyDieLayout();
        };

        const onMove = (event) => {
          if (!useParallax) return;
          const rect = canvas.getBoundingClientRect();
          if (!rect.width || !rect.height) return;
          pointer.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
          pointer.y = ((event.clientY - rect.top) / rect.height) * 2 - 1;
        };

        const onVisibility = () => {
          active = document.visibilityState === 'visible';
        };

        const animate = (now) => {
          if (!running) return;
          if (now - lastFrame < targetFrame) {
            rafId = window.requestAnimationFrame(animate);
            return;
          }

          const delta = lastFrame ? (now - lastFrame) / 16.67 : 1;
          lastFrame = now;

          if (!active) {
            rafId = window.requestAnimationFrame(animate);
            return;
          }

          time += 0.009 * delta;

          const px = useParallax ? pointer.x * 26 : 0;
          const py = useParallax ? pointer.y * 14 : 0;

          const pos = emberGeometry.attributes.position.array;
          for (let i = 0; i < emberCount; i += 1) {
            const i3 = i * 3;
            pos[i3 + 1] += speeds[i] * (isAboutVariant ? 0.35 : (effectMode === 'mist' ? 0.5 : 1)) * delta;
            pos[i3] += Math.sin(time + i * 0.08) * drift[i] * delta;

            if (pos[i3 + 1] > (isAboutVariant ? 4.2 : 3.8)) {
              pos[i3 + 1] = isAboutVariant ? -4 : -4.4;
            }
          }
          emberGeometry.attributes.position.needsUpdate = true;

          const targetX12 = useParallax ? (pointer.x * 0.6 + pointer.y * 0.12) : 0;
          const targetY12 = useParallax ? (pointer.y * 0.34 - pointer.x * 0.08) : 0;
          const targetX20 = useParallax ? (pointer.x * -0.28 + pointer.y * 0.24) : 0;
          const targetY20 = useParallax ? (pointer.y * 0.14 + pointer.x * 0.12) : 0;
          const targetX8 = useParallax ? (pointer.x * 0.2 - pointer.y * 0.28) : 0;
          const targetY8 = useParallax ? (pointer.y * -0.24 + pointer.x * 0.06) : 0;

          dieParallax.d12.x += (targetX12 - dieParallax.d12.x) * 0.09 * delta;
          dieParallax.d12.y += (targetY12 - dieParallax.d12.y) * 0.11 * delta;
          dieParallax.d20.x += (targetX20 - dieParallax.d20.x) * 0.07 * delta;
          dieParallax.d20.y += (targetY20 - dieParallax.d20.y) * 0.08 * delta;
          dieParallax.d8.x += (targetX8 - dieParallax.d8.x) * 0.12 * delta;
          dieParallax.d8.y += (targetY8 - dieParallax.d8.y) * 0.1 * delta;

          dieD12.rotation.x += 0.0032 * delta;
          dieD12.rotation.y += 0.0024 * delta;
          dieD12.position.x = dieBaseX.d12 + dieParallax.d12.x;
          dieD12.position.y = dieBaseY.d12 + Math.sin(time * (heroVariant === 'about' ? 0.8 : 1.2)) * dieBobAmp.d12 + dieParallax.d12.y;
          if (heroVariant === 'about') {
            dieD12.position.x += Math.cos(time * 0.55) * 0.004;
          }

          dieD20.rotation.x -= 0.0028 * delta;
          dieD20.rotation.y += 0.0021 * delta;
          dieD20.position.x = dieBaseX.d20 + dieParallax.d20.x;
          dieD20.position.y = dieBaseY.d20 + Math.sin(time * (heroVariant === 'about' ? 0.9 : 1.05) + 1.6) * dieBobAmp.d20 + dieParallax.d20.y;
          if (heroVariant === 'about') {
            dieD20.position.x += Math.sin(time * 0.6) * 0.004;
          }

          dieD8.rotation.x += 0.0035 * delta;
          dieD8.rotation.y -= 0.0026 * delta;
          dieD8.position.x = dieBaseX.d8 + dieParallax.d8.x;
          dieD8.position.y = dieBaseY.d8 + Math.sin(time * (heroVariant === 'about' ? 1 : 1.4) + 2.2) * dieBobAmp.d8 + dieParallax.d8.y;
          if (heroVariant === 'about') {
            dieD8.position.x += Math.cos(time * 0.52) * 0.003;
          }

          const flicker = 0.86 + Math.sin(time * 7.4) * 0.14;
          fireLight.intensity = isAboutVariant ? (0.42 + Math.sin(time * 2.3) * 0.05) : ((effectMode === 'arcane' ? 0.6 : 0.95) * flicker);
          glintLight.intensity = isAboutVariant ? (0.64 + Math.sin(time * 5.6) * 0.18) : 0.2;
          gemMaterial.emissiveIntensity = isAboutVariant ? (0.14 + Math.sin(time * 4.2) * 0.04) : gemMaterial.emissiveIntensity;
          if (heroVariant === 'about') {
            edgeLight.intensity = 0.4 + Math.sin(time * 2.8) * 0.08;
          }

          rafId = window.requestAnimationFrame(animate);

          if (useParallax) {
            root.rotation.y += ((pointer.x * 0.08) - root.rotation.y) * 0.06 * delta;
            root.rotation.x += ((-pointer.y * 0.05) - root.rotation.x) * 0.06 * delta;
            fireLight.position.x += ((pointer.x * 1.4) - fireLight.position.x) * 0.08 * delta;
            fireLight.position.y += ((1.2 - pointer.y * 0.9) - fireLight.position.y) * 0.1 * delta;
            edgeLight.position.x += ((-2.8 + pointer.x * 0.9) - edgeLight.position.x) * 0.08 * delta;
            edgeLight.position.y += ((1.7 - pointer.y * 0.6) - edgeLight.position.y) * 0.1 * delta;
          }

          renderer.render(scene, camera);
        };

        let ro = null;
        const onMobileResize = () => {
          if (mobileResizeTimer) clearTimeout(mobileResizeTimer);
          mobileResizeTimer = setTimeout(resize, 150);
        };

        if (mobileView) {
          window.addEventListener('orientationchange', onMobileResize, { passive: true });
        } else {
          ro = new ResizeObserver(resize);
          ro.observe(section);
        }
        document.addEventListener('visibilitychange', onVisibility);

        resize();
        canvas.classList.add('is-ready');

        if (useParallax) {
          section.addEventListener('pointermove', onMove, { passive: true });
          section.addEventListener('mousemove', onMove, { passive: true });
        }

        animate(0);

        instances.set(section, () => {
          running = false;
          if (rafId) window.cancelAnimationFrame(rafId);
          if (ro) ro.disconnect();
          if (useParallax) {
            section.removeEventListener('pointermove', onMove);
            section.removeEventListener('mousemove', onMove);
          }
          if (mobileView) {
            window.removeEventListener('orientationchange', onMobileResize);
            if (mobileResizeTimer) clearTimeout(mobileResizeTimer);
          }
          document.removeEventListener('visibilitychange', onVisibility);

          emberGeometry.dispose();
          emberMaterial.dispose();

          dieD12.children.forEach((child) => {
            child.geometry.dispose();
          });
          dieD20.children.forEach((child) => {
            child.geometry.dispose();
          });
          dieD8.children.forEach((child) => {
            child.geometry.dispose();
          });

          gemMaterial.dispose();
          metalMaterial.dispose();
          diceWire.dispose();

          renderer.dispose();
          canvas.classList.remove('is-ready');
        });
      } catch (error) {
        section.classList.add('hero--fx-fallback');
      }
    };

    const initHeroFx = () => {
      const sections = document.querySelectorAll(SECTION_SELECTOR);
      if (!sections.length || isReducedMotion()) return;

      const scheduleInit = (section) => {
        if (isMobile()) {
          const quality = resolveQuality(section.dataset.heroMobileQuality || 'low');
          if (quality === 'off') return;
        }

        // The heavy Three.js parse + WebGL setup is a long main-thread task, so
        // start it right after the cross-document view transition (~200ms) so the
        // FX appears promptly without the parse stuttering the transition. The
        // yields inside initScene keep input responsive while it runs;
        // Back/forward (bfcache) skips this work entirely.
        const run = () => {
          if ('requestIdleCallback' in window) {
            requestIdleCallback(() => initScene(section), { timeout: 1000 });
          } else {
            initScene(section);
          }
        };
        setTimeout(run, 200);
      };

      if (!('IntersectionObserver' in window)) {
        sections.forEach((section) => scheduleInit(section));
        return;
      }

      const io = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          scheduleInit(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '180px 0px 180px 0px', threshold: 0.15 });

      sections.forEach((section) => io.observe(section));
    };

    const cleanupHeroFx = (sectionId) => {
      if (!sectionId) return;
      const section = document.getElementById(`shopify-section-${sectionId}`);
      if (!section) return;
      const hero = section.querySelector('.hero[data-hero-three="true"]');
      if (!hero) return;
      const dispose = instances.get(hero);
      if (dispose) {
        dispose();
        instances.delete(hero);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHeroFx);
    } else {
      initHeroFx();
    }

    document.addEventListener('shopify:section:load', initHeroFx);
    document.addEventListener('shopify:section:unload', (event) => {
      if (!event || !event.detail) return;
      cleanupHeroFx(event.detail.sectionId);
    });
  })();

  // Animated hero heading — cycles the last word through product categories
  (() => {
    const COLORS = [
      '#f0b429', // amber    – Miniaturen / Miniatures
      '#6ecb63', // green    – Terrein / Terrain
      '#c47fc4', // purple   – Ruïnes / Ruins
      '#6ab4e8', // blue     – Gebouwen / Buildings
      '#d4874a', // earth    – Basing
      '#f0d060', // gold     – Kastelen / Castles
      '#4abfb0', // teal     – Modellen / Models
    ];
    const INTERVAL = 2800;
    const ANIM_MS  = 360;

    const initHeading = (heading) => {
      if (heading.querySelector('.hero__animated-word')) return;

      const raw = heading.dataset.animatedWords;
      if (!raw) return;

      const heroSection = heading.closest('section[data-hero-variant]');
      if (heroSection && heroSection.dataset.heroVariant === 'about') return;

      const words = raw.split(',').map(w => w.trim()).filter(Boolean);
      if (words.length < 2) return;

      const text = heading.textContent.trim();
      const lastSpace = text.lastIndexOf(' ');
      if (lastSpace === -1) return;

      const prefix = text.substring(0, lastSpace + 1);
      heading.innerHTML = `${prefix}<span class="hero__animated-word"></span>`;
      const span = heading.querySelector('.hero__animated-word');

      let index = 0;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const setWord = () => {
        span.textContent = words[index].toUpperCase();
        span.style.color = COLORS[index % COLORS.length];
      };

      const advance = () => {
        if (reduced) {
          index = (index + 1) % words.length;
          setWord();
          return;
        }
        span.classList.remove('word-in');
        span.classList.add('word-out');
        setTimeout(() => {
          index = (index + 1) % words.length;
          setWord();
          span.classList.remove('word-out');
          void span.offsetWidth;
          span.classList.add('word-in');
        }, ANIM_MS);
      };

      setWord();
      if (!reduced) {
        span.classList.add('word-in');
        setInterval(advance, INTERVAL);
      }
    };

    const init = () => {
      document.querySelectorAll('.hero__heading[data-animated-words]').forEach(initHeading);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-arrivals"]) return;
  try {
    
  // Minimal product interactions
  document.addEventListener('DOMContentLoaded', function() {
    const addToCartButtons = document.querySelectorAll('.new-arrivals__add-to-cart');
    addToCartButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        const form = this.closest('.form');
        if (form) {
          // Prevent default form submission for demonstration
          e.preventDefault();
          // Add your cart functionality here
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details"]) return;
  try {
    
  function initProductTabs() {
    const tabs = document.querySelector('[data-tabs]');
    if (!tabs) return;

    const nav = tabs.querySelector('.tabs__nav');
    const buttons = nav.querySelectorAll('.tabs__btn');
    const panels = tabs.querySelectorAll('.tabs__panel');

    buttons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const target = button.getAttribute('data-tab-target');

        // Update buttons
        buttons.forEach(btn => {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-selected', 'false');
        });
        button.classList.add('is-active');
        button.setAttribute('aria-selected', 'true');

        // Update panels
        panels.forEach(panel => {
          panel.hidden = true;
          panel.classList.remove('is-active');
        });
        const activePanel = document.getElementById(target);
        if (activePanel) {
          activePanel.hidden = false;
          activePanel.classList.add('is-active');
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function() { initProductTabs(); });
  document.addEventListener('shopify:section:load', function() { initProductTabs(); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  // Fuzzy fallback for the search page. Two responsibilities:
  //  1. Zero results for ?q=... -> ask WFFuzzySearch for a space-agnostic /
  //     typo-tolerant correction and redirect to ?q=corrected&oq=original.
  //  2. Landed on corrected results (?oq= present) -> show a banner naming
  //     both queries, with an escape hatch (&exact=1) that suppresses step 1.
  function initSearchCorrection() {
    var section = document.querySelector('.search-page');
    if (!section) return;
    var params = new URLSearchParams(window.location.search);
    var q = params.get('q');
    if (!q) return;
    var oq = params.get('oq');
    var noResults = !!section.querySelector('.search-no-results');

    if (oq && !noResults) {
      var header = section.querySelector('.section-header');
      if (!header || section.querySelector('.search-corrected-banner')) return;
      var banner = document.createElement('p');
      banner.className = 'search-corrected-banner';
      var text = (section.getAttribute('data-corrected-text') || 'No results for "%o". Showing results for "%c" instead.')
        .replace('%o', oq)
        .replace('%c', q);
      var link = document.createElement('a');
      link.textContent = (section.getAttribute('data-search-instead') || 'Search instead for "%s"').replace('%s', oq);
      link.href = (section.getAttribute('data-search-url') || '/search') + '?q=' + encodeURIComponent(oq) + '&exact=1';
      banner.appendChild(document.createTextNode(text + ' '));
      banner.appendChild(link);
      header.appendChild(banner);
      return;
    }

    if (noResults && !oq && !params.get('exact') && window.WFFuzzySearch) {
      window.WFFuzzySearch.correct(q).then(function (corrected) {
        if (!corrected) return;
        var url = (section.getAttribute('data-search-url') || '/search')
          + '?q=' + encodeURIComponent(corrected)
          + '&oq=' + encodeURIComponent(q);
        window.location.replace(url);
      });
    }
  }

  document.addEventListener('DOMContentLoaded', initSearchCorrection);
  document.addEventListener('shopify:section:load', initSearchCorrection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"]) return;
  try {
    
  // Minimal testimonial interactions
  document.addEventListener('DOMContentLoaded', function() {
    const testimonialCards = document.querySelectorAll('.testimonial-card');
    testimonialCards.forEach(card => {
      card.addEventListener('mouseenter', function() {
        this.style.transform = 'translateY(-4px)';
      });

      card.addEventListener('mouseleave', function() {
        this.style.transform = 'translateY(0)';
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
